'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var ResponsiveModal = require('../ResponsiveModal/ResponsiveModal.js');
var modalState = require('./modalState.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var ModalContainer = function () {
    var _a = React.useState([]), ids = _a[0], setIds = _a[1];
    modalState.states.setIds = setIds;
    return (React__default['default'].createElement(React__default['default'].Fragment, null, ids.length > 0 && ids.map(function (id) {
        var props = tslib_es6.__assign({}, modalState.states.props[id]);
        props.onClose; var component = props.component, others = tslib_es6.__rest(props, ["onClose", "component"]);
        var handleClose = function () {
            props.onClose();
            modalState.states.removeId(id);
        };
        var newComponent = tslib_es6.__assign(tslib_es6.__assign({}, component), { props: tslib_es6.__assign(tslib_es6.__assign({}, component.props), { close: handleClose }) });
        return (React__default['default'].createElement(ResponsiveModal, tslib_es6.__assign({ key: id, isOpen: true, onClose: handleClose }, others), newComponent));
    })));
};
var defaultOptions = {
    onClose: function () { },
    size: 'sm',
    title: ''
};
var show = function (component, options) {
    modalState.states.show(tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign({}, defaultOptions), options), { component: component }));
};

exports.ModalContainer = ModalContainer;
exports.defaultOptions = defaultOptions;
exports.show = show;
//# sourceMappingURL=FunctionModal.js.map
